"use client"

import { FooterLinksItemType } from "@/types/global"
import { useTranslation } from "react-i18next"

export const FooterLinkSectionElement = ({
  footerLinks,
}: {
  footerLinks: FooterLinksItemType[]
}) => {
  return (
    <div className="flex flex-col gap-y-6 xsmall:flex-row items-start justify-between py-6">
      <div className="text-small-regular gap-10 md:gap-x-16 grid grid-cols-2 lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 w-full">
        {footerLinks?.map((footerLinkGroup) => (
          <FooterGroup
            key={footerLinkGroup.id}
            footerLinkGroup={footerLinkGroup}
          />
        ))}
      </div>
    </div>
  )
}

export const FooterGroup = ({
  footerLinkGroup,
}: {
  footerLinkGroup: FooterLinksItemType
}) => {
  const { t } = useTranslation()

  const translateLabel = (label: string) => {
    const normalized = label?.trim().toLowerCase()

    switch (normalized) {
      case "popular categories":
        return t("footer.popularCategories")
      case "coorporate":
      case "corporate":
        return t("footer.corporate")
      case "sözleşmeler":
      case "sözlesmeler":
      case "sã¶zleåÿmeler":
      case "sã¶zleåŸmeler":
      case "sÃ¶zleÅŸmeler":
        return t("footer.agreements")
      case "member":
        return t("footer.member")
      default:
        return label
    }
  }

  return (
    <div key={footerLinkGroup.id} className="flex flex-col gap-y-2">
      <span className="txt-small-plus txt-ui-fg-base">
        {translateLabel(footerLinkGroup.label)}
      </span>
      <ul className="grid grid-cols-1 gap-y-2 text-ui-fg-subtle txt-small">
        {footerLinkGroup.links && footerLinkGroup.links.map((footerLink) => (
          <li key={footerLink.id}>
            <a
              href={footerLink.url}
              target="_blank"
              rel="noreferrer"
              className="hover:text-ui-fg-base"
            >
              {footerLink.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
